import { useEffect } from 'react';
import { NBXStorage } from '@nbx/frontend-helpers/storage';

const STORAGE_KEY = 'location.from';

export const useRedirectAfterLogin = (user, session, history) => {
  useEffect(() => {
    if (!user || !session) return;
    NBXStorage.getItem(STORAGE_KEY)
      .then(from => from && history.push(from))
      .then(NBXStorage.removeItem(STORAGE_KEY));
  }, [user, session, history]);
};
